// extracted by mini-css-extract-plugin
export default {"fullCardWidthActionOverlay":"carddeck-actionoverlay_fullCardWidthActionOverlay__uDiS-"};